import * as d3 from "d3";
import router from "../router";
import i18n from "../lang/lang";
import store from "../store/index";
export const ZERO_VALUE_REPLACE = -1;

const width = 100; // % of the parentelement
const height = 100;
var treemap = d3.treemap().size([width, height]).paddingInner(0).round(false);

var colors = [
  {
    backgroundColor: "#009355", // Positive
    fontColor: "#fff",
  },
  {
    backgroundColor: "#e60246", // negative
    fontColor: "#fff",
  },
  {
    backgroundColor: "#ffbe00", // intermediate
    fontColor: "#000",
  },
  {
    backgroundColor: "#999999", // notAvailable
    fontColor: "#000",
  },
  {
    backgroundColor: "#f79646", // orange
    fontColor: "#000",
  },
];

export function ChartTreemap(data, alias) {
  this.alias = alias || "treemap";
  const formattedTreemapData = formatTreemapIndicators(
    JSON.parse(JSON.stringify(data))
  );
  var color = function (index, containsError) {
    return selectColorPillars(index, containsError);
  };

  data = {
    name: "Treemap",
    children: formattedTreemapData,
  };

  var nodes = d3.hierarchy(data).sum(function (d) {
    return d.value ? 1 : 0;
  });

  treemap(nodes);
  var chart = d3.select("#" + this.alias);
  var cells = createCells(chart, nodes);
  cells.attr("title", function (d) {
    return i18n.tc(d.data.name) ? i18n.tc(d.data.name) : "null";
  });

  stylizeCelss(cells, color);
  cells.style("background-color", function (d) {
    while (d.depth > 2) {
      d = d.parent;
    }
    return color(d.data.index, containsError(d.data))["backgroundColor"];
  });
  cells.on("click", function (d) {
    zoom(d, chart, "/reports/gender-gap/" + d.parent.data.id + "/" + d.data.id);
  });
  labelCellsPillars(cells, color);

  var parent = d3
    .select(".up")
    .datum(nodes)
    .on("click", function (d) {
      zoom(d, chart);
    });
  d3.select(".up").style("visibility", "hidden");
}

export function ChartTreemapConsolidated(data, alias) {
  this.alias = alias || "treemap";
  const formattedTreemapData = formatTreemapIndicators(
    JSON.parse(JSON.stringify(data))
  );
  var color = function (index, containsError) {
    return selectColorPillars(index, containsError);
  };

  data = {
    name: "Treemap",
    children: formattedTreemapData,
  };

  var nodes = d3.hierarchy(data).sum(function (d) {
    return d.value ? 1 : 0;
  });
  treemap(nodes);
  var chart = d3.select("#" + this.alias);
  var cells = createCells(chart, nodes);
  cells.attr("title", function (d) {
    return i18n.tc(d.data.name) ? i18n.tc(d.data.name) : "null";
  });
  cells.on("click", function (d) {
    zoom(
      d,
      chart,
      "/reports/consolidated/" + d.parent.data.id + "/" + d.data.id
    );
  });

  stylizeCelss(cells, color);
  cells.style("background-color", function (d) {
    while (d.depth > 2) {
      d = d.parent;
    }
    return color(d.data.index, containsError(d.data))["backgroundColor"];
  });

  labelCellsPillars(cells, color);

  var parent = d3
    .select(".up")
    .datum(nodes)
    .on("click", function (d) {
      zoom(d, chart);
    });
  d3.select(".up").style("visibility", "hidden");
}

var evaluationBranchColors = [
  {
    backgroundColor: "#1E4381", // 76 - 100
    fontColor: "#fff",
  },
  {
    backgroundColor: "#6f3996", // 50-75
    fontColor: "#fff",
  },
  {
    backgroundColor: "#97cafc", // 26 - 50
    fontColor: "#1E4381",
  },
  {
    backgroundColor: "#e9cafc", // 0 - 25
    fontColor: "#1E4381",
  },
  {
    backgroundColor: "#999999", // pending
    fontColor: "#000",
  },
];

function calculateBranchValue(children) {
  let branchValue = null;
  for (let child of children) {
    let childValue = null;
    if (child.children && child.children.length) {
      childValue = calculateBranchValue(child.children);
    } else {
      if (
        typeof child.evaluation_status !== "undefined" &&
        child.evaluation_status !== null
      ) {
        childValue = child.evaluation_status;
      }
    }
    if (childValue) {
      if (branchValue) {
        branchValue += childValue;
      } else {
        branchValue = childValue;
      }
    }
  }
  return branchValue ? branchValue / children.length : branchValue;
}

function selectColorRequirements(status, weight, children) {
  if (children && children.length) {
    let branchValue = calculateBranchValue(children);

    if (branchValue === null) {
      return evaluationBranchColors[4];
    }

    if (branchValue > 100) {
      console.error("Why branch value is greater than 100%?", branchValue);
    }

    if (branchValue >= 76) {
      return evaluationBranchColors[0];
    } else if (branchValue >= 50) {
      return evaluationBranchColors[1];
    } else if (branchValue >= 26) {
      return evaluationBranchColors[2];
    } else if (branchValue >= 0) {
      return evaluationBranchColors[3];
    } else {
      return evaluationBranchColors[4];
    }
  } else {
    if (status >= 100) {
      return colors[0];
    } else if (status >= 75) {
      return colors[2];
    } else if (status >= 50) {
      return colors[4];
    } else if (status > 0) {
      return colors[1];
    } else {
      return colors[3];
    }
  }
}

function assignSameSizeToEvaluationNodes(child, percentageToShare) {
  if (child.children && child.children.length) {
    for (let ch of child.children) {
      assignSameSizeToEvaluationNodes(
        ch,
        percentageToShare / child.children.length
      );
    }
  } else {
    child.samePercentage = percentageToShare;
  }
}
export function EvaluationChartTreemap(data, alias) {
  this.alias = alias || "treemap";
  const formattedTreemapData = JSON.parse(JSON.stringify(data));
  data = {
    name: "Treemap",
    children: formattedTreemapData,
  };
  assignSameSizeToEvaluationNodes(data, 1);

  var nodes = d3.hierarchy(data).sum((d) => {
    return d.samePercentage;
  });
  treemap(nodes);
  var chart = d3.select("#" + this.alias);
  var cells = createCells(chart, nodes);
  stylizeCelss(cells, selectColorRequirements);
  cells.style("background-color", function (d) {
    var status = d.data.evaluation_status;
    var weight = d.data.evaluation_administrator_node_percentualWeight;
    var children = d.data.children;
    return selectColorRequirements(status, weight, children)["backgroundColor"];
  });
  cells.on("click", function (d) {
    zoom(d, chart);
  });
  labelCellsRequirements(cells, selectColorRequirements);

  var parent = d3
    .select(".up")
    .datum(nodes)
    .on("click", function (d) {
      zoom(d, chart);
    });
  d3.select(".up").style("visibility", "hidden");

  calculateConventionLevel(nodes.children);
}

function calculateConventionLevel(nodes) {
  let level = "branch";
  for (let node of nodes) {
    if (!node.data.children?.length) {
      level = "leaf";
    }
  }
  console.log("dispatching SET_REPORT_CONVENTION_LEVEL");
  store.commit("SET_REPORT_CONVENTION_LEVEL", level);
}

function selectColorPillars(index, containsError) {
  if (containsError === true || index === undefined || index === null) {
    return colors[3];
  }
  if (index <= 50) {
    return colors[1];
  } else if (index > 75) {
    return colors[0];
  } else {
    return colors[2];
  }
}

function containsError(data) {
  if (
    data &&
    (data.errorOnIndexFormula === "true" ||
      data.errorOnAllIndexIndicators === "true")
  ) {
    return true;
  }
  return false;
}

function formatTreemapIndicators(data) {
  for (const pillar of data) {
    for (const indicator of pillar.children) {
      if (!indicator.value || indicator.value === 0) {
        indicator.value = ZERO_VALUE_REPLACE;
      }
    }
  }
  return data;
}

function createCells(chart, nodes) {
  var cells = chart
    .selectAll(".node")
    .data(nodes.descendants())
    .enter()
    .append("div")
    .attr("class", function (d) {
      return "node level-" + d.depth;
    });

  return cells;
}

function stylizeCelss(cells, color) {
  var x = d3.scaleLinear().domain([0, width]).range([0, width]);
  var y = d3.scaleLinear().domain([0, height]).range([0, height]);

  cells
    .style("left", function (d) {
      return x(d.x0) + "%";
    })
    .style("top", function (d) {
      return y(d.y0) + "%";
    })
    .style("width", function (d) {
      return x(d.x1) - x(d.x0) + "%";
    })
    .style("height", function (d) {
      return y(d.y1) - y(d.y0) + "%";
    });

  cells.style("background-color", function (d) {
    while (d.depth > 2) {
      d = d.parent;
    }
    return color(d.data.index, containsError(d.data))["backgroundColor"];
  });
}

function labelCellsPillars(cells, color) {
  var cellsDiv = cells.append("div").attr("class", "label");

  cellsDiv
    .append("p")
    .text(function (d) {
      return i18n.tc(d.data.acronym) + " - " + i18n.tc(d.data.name);
    })
    .style("font-size", "1rem")
    .style("line-height", "1.2rem")
    .style("color", function (d) {
      return color(d.data.index, containsError(d.data))["fontColor"];
    });
  ["fontColor"];
  cellsDiv
    .append("p")
    .attr("class", "index leaf")
    .text(function (d) {
      let message = "";
      if (d.depth === 2) {
        message =
          " - " +
          i18n.tc("label_reports_genderGap_generalSummary_openIndicator");
      }
      return parseInt(d.data.index) + "%" + message;
    })
    .style("font-size", "1rem")
    .style("line-height", "1.2rem")
    .style("color", function (d) {
      return color(d.data.index, containsError(d.data))["fontColor"];
    });
}

function abreviateText(text) {
  if (text.length > 250) {
    let temp = text.slice(0, 250);
    return temp + "...";
  } else {
    return text;
  }
}

function labelCellsRequirements(cells, color) {
  var cellsDiv = cells.append("div").attr("class", "label");

  cellsDiv
    .append("p")
    .text(function (d) {
      var abreviatedText = abreviateText(
        i18n.tc(d.data.evaluation_administrator_node_requirementName)
      );
      return (
        i18n.tc(d.data.evaluation_administrator_node_nomenclature) +
        " - " +
        abreviatedText
      );
    })
    .style("font-size", "1rem")
    .style("line-height", "1.2rem")
    .style("color", function (d) {
      var status = d.data.evaluation_status;
      var weight = d.data.evaluation_administrator_node_percentualWeight;
      var children = d.data.children;
      return color(status, weight, children)["fontColor"];
    });
  /*cellsDiv
    .append("p")
    .attr("class", "index")
    .text(function (d) {
      return i18n.tc(d.data.evaluation_administrator_node_percentualWeight) + "%"
    })
    .style("font-size", "1rem")
    .style("line-height", "1.2rem")
    .style("color", function (d) {
      var status = d.data.evaluation_status
      var weight = d.data.evaluation_administrator_node_percentualWeight
      var hasChildren = d.data.children ? true : false
      return color(status, weight, hasChildren)["fontColor"];
    });*/
}

function zoom(d, chart, path) {
  // http://jsfiddle.net/ramnathv/amszcymq/
  var upButton = d3.select(".up");
  var x = d3.scaleLinear().domain([0, width]).range([0, width]);
  var y = d3.scaleLinear().domain([0, height]).range([0, height]);

  if (d.depth === 0) {
    upButton.style("visibility", "hidden");
  } else {
    upButton.style("visibility", "initial");
  }
  if (d.depth === 2 && path) {
    router.push(path);
  }

  var currentDepth = d.depth;
  upButton.datum(d.parent);

  x.domain([d.x0, d.x1]);
  y.domain([d.y0, d.y1]);

  var t = d3.transition().duration(800).ease(d3.easeCubicOut);
  var cells = chart.selectAll(".node");
  cells
    .transition(t)
    .style("left", function (d) {
      return x(d.x0) + "%";
    })
    .style("top", function (d) {
      return y(d.y0) + "%";
    })
    .style("width", function (d) {
      return x(d.x1) - x(d.x0) + "%";
    })
    .style("height", function (d) {
      return y(d.y1) - y(d.y0) + "%";
    });
  cells
    .filter(function (d) {
      return d.ancestors();
    })
    .classed("hide", function (d) {
      return !!d.children;
    });
  cells
    .filter(function (d) {
      return d.depth > currentDepth;
    })
    .classed("hide", false);

  calculateConventionLevel(d.children);
}
